module.exports = __webpack_public_path__ + "static/media/26.466da254.jpg";